module.exports = (__parcel__import__("36f0K")).then(() => parcelRequire('4MKVl'));